import React from 'react';
import s from './Input.module.css';
import { MAX_FIELD_ROWS, resizeTextareaElement } from './Input';

export function Textarea({
  value,
  onChange,
  placeholder = '',
  ariaLabel,
  textareaRef,
  className = '',
  wrapperClassName = '',
  rows = 1,
  maxRows = MAX_FIELD_ROWS,
  ...rest
}) {
  const innerRef = React.useRef(null);
  const ref = textareaRef ?? innerRef;

  const syncHeight = React.useCallback(() => {
    resizeTextareaElement(ref.current, maxRows, rows);
  }, [ref, maxRows, rows]);

  React.useLayoutEffect(() => {
    syncHeight();
  }, [value, rows, syncHeight]);

  const handleChange = (e) => {
    if (typeof onChange === 'function') onChange(e);
    resizeTextareaElement(e.currentTarget, maxRows, rows);
  };

  const hasValue = value != null && value !== '';

  return (
    <div className={`${s.box} ${s.textareaBox} ${wrapperClassName}`.trim()}>
      <textarea
        ref={ref}
        className={`${s.textarea} ${hasValue ? s.textareaWithClear : ''} ${className}`.trim()}
        placeholder={placeholder}
        value={value ?? ''}
        onChange={handleChange}
        aria-label={ariaLabel}
        rows={rows}
        {...rest}
      />
    </div>
  );
}
